import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4fe1474a"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "background"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "top-back"
};
const _hoisted_4 = {
  class: "icon-main"
};
const _hoisted_5 = ["src"];

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 甜心公园 ");

const _hoisted_7 = {
  class: "mid-back"
};
const _hoisted_8 = {
  class: "left-back"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "big-word"
}, "真人认证、安全守护", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "mid-title"
}, "在这里，心动始于真实，相逢终于灵魂", -1));

const _hoisted_11 = {
  class: "btn-back"
};
const _hoisted_12 = {
  class: "btn-backs"
};
const _hoisted_13 = ["src"];

const _hoisted_14 = /*#__PURE__*/_createTextVNode("Android");

const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "beian-top"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 网站备案/许可证号：");

const _hoisted_18 = {
  class: "beian-link",
  target: "_blank",
  href: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602013692"
};
const _hoisted_19 = ["src"];

const _hoisted_20 = /*#__PURE__*/_createTextVNode("粤公网安备 44010602013692号");

const _hoisted_21 = /*#__PURE__*/_createTextVNode("    ");

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 网站备案/许可证号：");

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "beian-link",
  target: "_blank",
  href: "https://beian.miit.gov.cn/"
}, "琼ICP备2024042973号-3 ", -1));

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 联系方式 ：tianxinkefu@163.com ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_contact_tip = _resolveComponent("contact-tip");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $setup.quan,
    class: "icon"
  }, null, 8, _hoisted_5), _hoisted_6]), _createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.tips.showTip && $setup.tips.showTip(...args))
  }, "关于我们")]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "down-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.downloadAndroid && $setup.downloadAndroid(...args))
  }, [_createElementVNode("img", {
    src: $setup.android,
    class: "down-icon"
  }, null, 8, _hoisted_13), _hoisted_14])])])]), _createElementVNode("img", {
    src: $setup.rightimg,
    class: "rightimg"
  }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("a", _hoisted_18, [_createElementVNode("img", {
    class: "beian-img",
    src: $setup.beian
  }, null, 8, _hoisted_19), _hoisted_20]), _hoisted_21, _hoisted_22, _hoisted_23, _hoisted_24, _hoisted_25, _hoisted_26])]), _createVNode(_component_contact_tip, {
    ref: "tips"
  }, null, 512), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.bigImg && $setup.bigImg(...args))
  }, null, 512), [[_vShow, $setup.big]]), _withDirectives(_createElementVNode("div", {
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.bigImg && $setup.bigImg(...args)),
    class: "code-title"
  }, "扫描二维码下载", 512), [[_vShow, $setup.big]])]);
}